import axios from "axios";
import { api } from "@/lib/api";

export async function uploadToGallery(file, onProgress) {
  const { data: sig } = await api.get("/cloudinary/signature?folder=uploads/gallery");
  const fd = new FormData();
  fd.append("file", file);
  fd.append("api_key", sig.api_key);
  fd.append("timestamp", sig.timestamp);
  fd.append("signature", sig.signature);
  fd.append("folder", sig.folder);
  const kind = file.type.startsWith("video") ? "video" : "image";
  const res = await axios.post(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/${kind}/upload`, fd, {
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
  });
  return { url: res.data.secure_url, media_type: kind };
}

export const fbShareUrl = (aid, mid) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/share/gallery/${aid}${mid ? `?m=${mid}` : ""}`;

export const openFbShare = (url) => {
  const a = document.createElement("a");
  a.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

const LIKES_KEY = "pbGalLikes";
export const likedSet = () => {
  try { return new Set(JSON.parse(localStorage.getItem(LIKES_KEY) || "[]")); } catch { return new Set(); }
};
export const saveLiked = (set) => localStorage.setItem(LIKES_KEY, JSON.stringify([...set]));
